/*
 * Field whitelist for the race admin edit form. Shared by the admin edit
 * route and the editRace drawer so both show the same fields.
 */

export const RACE_EDIT_FIELDS = [
    'title', 'tag', 'isCancelled', 'forcePaymentBeforeSignupApproval', 'signupPaymentReservationMinutes',
    'closeSignupWhenClassIsFull',
    'signupRequireSportsClub', 'signupRequireKennel', 'signupRequireBirth', 'juniorMaxAge', 'signupRequireCountry',
    'signupRequireAddress', 'signupRequireLicenseNumber', 'signupRequireQualifying',
    'ingress', 'body', 'info', 'terms', 'trackInfo', 'qualifying', 'emergencyInfo', 'showResults',
    'showTracking', 'hasTracking', 'shippingDaysBefore', 'shippingDaysAfter', 'estimatedTrackers',
    'addAutoResultsHidden', 'hasResults', 'hasNews', 'hideResults', 'hasLiveFeed', 'liveFeedStartDate',
    'liveFeedEndDate', 'isSubscriptionsTracking', 'isSubscriptionsStreaming', 'isSubscriptionsNews',
    'isSubscriptionsResults', 'isAllAllowedToPublishNews', 'isMediaAllowedToPublishNews', 'rules',
    'declaration', 'veterinaryInfo', 'checkpointsInfo', 'trailDescription', 'program', 'prices',
    'timezone', 'startDate', 'startDateRaceLocal',
    'endDate', 'endDateRaceLocal', 'signupStartDate', 'signupStartDateRaceLocal', 'signupEndDate', 'signupEndDateRaceLocal',
    'signupPaymentDueDate', 'contactEmail', 'contactCellphone',
    'facebook', 'instagram', 'images', 'files', 'autoplayVideo', 'bankCompany', 'bankAddress',
    'bankPostalcode', 'bankPostalplace', 'bankAccountNumber', 'bankIBAN', 'bankSWIFT', 'bankMarkPayment',
    'bankDueDate', 'bankOtherInfo', 'vippsTermsOfSale', 'emailSender', 'smsSender', 'raceAdmins',
    'mediaWorkers', 'timeTrackers', 'tdLeaders', 'raceLeaders', 'tvRadioProducers', 'bodyEn', 'programEn',
    'checkpointsInfoEn', 'termsEn', 'rulesEn', 'veterinaryInfoEn', 'declarationEn', 'emergencyInfoEn',
    'qualifyingEn', 'trackInfoEn', 'pricesEn', 'vippsTermsOfSaleEn', 'subscriptionTitle', 'subscriptionBody',
    'active', 'hideFromList', 'subscriptionBox1Title', 'subscriptionBox1Body', 'subscriptionBox1Button',
    'subscriptionBox1Price', 'subscriptionBox2Title', 'subscriptionBox2Body', 'subscriptionBox2Button',
    'subscriptionBox2Price', 'subscriptionBox3Title', 'subscriptionBox3Body', 'subscriptionBox3Button',
    'subscriptionBox3Price', 'link1', 'link1Text', 'link2', 'link2Text', 'link3', 'link3Text',
];
